const Footer = () => {
    return (
        <footer className="text-[#a1a1a1] text-sm flex justify-center py-2 bg-[#222525]">
            <p>Jani Luostarinen 2025. Made using React, Tailwindcss and font awesome.</p>
        </footer>
    );
}
export default Footer;